// Subscription
export const FREE = "FREE";
// Initial state
export const initialState = {
  uid: null,
  email: "",
  name: null,
  // Script data
  hasScript: false,
  hasCustomScript: false,
  needsScriptUpdate: false,
  scriptVersion: "0.0",
  hasDoneOnboarding: false,
  hasReviewed: true,
  hasChatEnabled: false,
  hasMultipleProducts: false,
  hasSellingPlanEnabled: false,
  hasNewBillingPlans: false,
  isDisabled: false,
  isDisabledIS: false,
  isDisabledBIS: false,
  isCSVEnabled: false,
  // It was changed to true to prevent loading the big file /assets/instructions.gif by default
  isAppBlockEnabled: true,
  deepLink: "",
  lastProductUpdate: true,
  freePlan: {
    used: {
      preorders: 0,
      instock: 0,
      emailsPO: 0,
      emailsBIS: 0,
    },
    limits: {
      preorders: 10,
      instock: 10,
      emailsPO: 10,
      emailsBIS: 50,
    },
  },
  paidPlan: {
    preorders: 0,
    instock: 0,
    emailsPO: 0,
    emailsBIS: 0,
  },
  subscription: {
    chargedId: null,
    plan: FREE,
    isOldUnlimited: false,
    isUnlimitedPO: false,
    isUnlimitedIS: false,
    isUnlimitedBIS: false,
    price: 0,
    preorders: 0,
    preordersPrice: 0,
    instock: 0,
    instockPrice: 0,
    bisNotifications: 0,
    bisNotificationsPrice: 0,
    subscribedAt: {
      seconds: 1611532800,
    },
  },
  createdAt: {
    seconds: 1625482070,
  },
  settings: {
    templates: {
      PO: "",
      BIS: "",
      CS: "",
      IS: "",
    },
  },
  preferences: {
    isTableExpanded: true,
  },
  features: {
    isInStockEnabled: false,
  },
  locale: "en",
  localeApp: "en",
  planType: "",
  tutorial: {
    onInstall: true,
    firstStep: true,
    showEmojiReviewModal: false,
  },
  selectors: {
    addToCartButton: "",
    form: "",
    variant: "",
    message: "",
    timer: "",
    badge: "",
    collection: null,
  },
};
